import { IPublishTermsRequest } from '../../../../../repositories/billing-tariffs/v1/publish-terms';

export const isParametersValid = (parameters: IPublishTermsRequest) => {
  const { id, category, locationPath } = parameters;

  return (
    // у объявления должна быть категория
    !!category &&
    // у объявления должен быть ID или locationPath
    (!!id || (Array.isArray(locationPath) && locationPath.length > 0))
  );
};
